import { render, staticRenderFns } from "./GestionActividades.vue?vue&type=template&id=6f47b319&"
import script from "./GestionActividades.vue?vue&type=script&lang=js&"
export * from "./GestionActividades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports